export const TYPE_WRITER_STRINGS = ['Développeur Full Stack'];
